import React, { useEffect, useRef } from "react";

export function Video({ videoId, onEnd, loop }) {
  const iframeRef = useRef(null);

  // Workaround: fallback timing if you don't use YouTube API
  useEffect(() => {
    if (onEnd && !loop) {
      const fallback = setTimeout(() => {
        onEnd();
      }, 60000); // assumes video is ~60 seconds
      return () => clearTimeout(fallback);
    }
  }, [onEnd, loop]);

  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1${
    loop ? `&loop=1&playlist=${videoId}` : ""
  }`;

  return (
    <div className="ratio ratio-16x9">
      <iframe
        ref={iframeRef}
        src={embedUrl}
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
